import { StoreHeaderBrand } from './StoreHeaderBrand'
import { StoreMobileExploreMenu } from './StoreMobileExploreMenu'

/** Store top bar for mobile & tablet (desktop uses StoreHeader). */
export function StoreMobileHeader() {
  return (
    <header className="store-mobile-header lg:hidden" aria-label="Store">
      <div className="store-mobile-header-shell">
        <div className="store-container store-mobile-header-inner">
          <StoreHeaderBrand className="max-w-[calc(100%-3rem)]" />
          <StoreMobileExploreMenu />
        </div>
      </div>
    </header>
  )
}
